<template>
  <section class="agent-report tw-space-y-4">
    <h1 class="tw-text-xl tw-text-primary tw-font-bold tw-select-none">
      Agent Report
    </h1>
    <div
      class="
        chart
        tw-h-[30rem]
        tw-w-[50rem]
        tw-flex
        tw-justify-center
        tw-items-center
        tw-text-gray-300
        tw-text-xl
      "
      ref="chart"
    ></div>
  </section>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "AgentReport",
  components: {},
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    this.chart = echarts.init(this.$refs.chart);
    this.chart.setOption({
      title: {
        text: "Agent",
        subtext: "Mockup Data",
        left: "center",
      },
      tooltip: {
        trigger: "item",
      },
      series: [
        {
          name: "Agent status",
          type: "pie",
          radius: "60%",
          data: [
            { value: 37, name: "Online" },
            { value: 20, name: "Offline" },
          ],
          //   emphasis: {
          //     itemStyle: {
          //       shadowBlur: 10,
          //       shadowOffsetX: 0,
          //       shadowColor: "rgba(0, 0, 0, 0.5)",
          //     },
          //   },
        },
      ],
      color: ["#2c2a74", "#e5e7eb"],
    });
  },
};
</script>

<style>


</style>